import React from "react";
import { PureComponent } from "react";
import {
  FormGroup,
  Table,
  Input,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  CustomInput,
} from "reactstrap";
// import './SearchBar.css';
import OverlayLoading from "../Commons/OverlayLoading.jsx";
import { Link } from "react-router-dom";
import moment from "moment";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
class ArticleForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  formatTime(dateString) {
    return moment(dateString).format("YYYY-MM-DD");
  }

  render() {
    return (
      <div>
        <div className="d-flex align-items-center justify-content-around">
          <button
            type="button"
            className="btn btn-default"
            style={{ flex: 1 }}
            disabled={this.props.loading}
            onClick={this.props.submitArticle}
          >
            保存
          </button>
          <button
            type="button"
            className="btn btn-default"
            style={{ flex: 1 }}
            onClick={this.props.togglePreview}
          >
            預覽
          </button>
        </div>

        <div className="d-flex align-items-center py-4">
          <div className="custom-control custom-radio">
            <input
              className="custom-control-input"
              id="customRadio1"
              name="customRadio"
              type="radio"
              checked={this.props.data.status === "draft"}
              value="draft"
              onChange={(e) => this.props.onTextInputChange(e, "status")}
            />
            <label className="custom-control-label" htmlFor="customRadio1">
              草稿文章
            </label>
          </div>
          <div className="custom-control custom-radio ml-2">
            <input
              className="custom-control-input"
              id="customRadio2"
              name="customRadio"
              type="radio"
              checked={this.props.data.status === "published"}
              value="published"
              onChange={(e) => this.props.onTextInputChange(e, "status")}
            />
            <label className="custom-control-label" htmlFor="customRadio2">
              正式發布
            </label>
          </div>
        </div>

        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            標題
          </label>
          <Input
            id="example-text-input"
            type="text"
            value={this.props.data.title}
            onChange={(e) => this.props.onTextInputChange(e, "title")}
          />
        </FormGroup>
        <FormGroup>
          <label className="form-control-label" htmlFor="example-text-input">
            作者
          </label>
          <Input
            id="example-text-input"
            type="text"
            value={this.props.data.author}
            onChange={(e) => this.props.onTextInputChange(e, "author")}
          />
        </FormGroup>
        <FormGroup>
          <label htmlFor="exampleFormControlSelect1">選擇分類</label>
          <Input
            id="exampleFormControlSelect1"
            type="select"
            onChange={(e) => this.props.handleCheckBoxChange(e)}
          >
            <option
              selected={
                this.props.data.category_ids
                  ? this.props.data.category_ids.indexOf(7) !== -1
                  : false
              }
              value={7}
            >
              直播
            </option>
            <option
              selected={
                this.props.data.category_ids
                  ? this.props.data.category_ids.indexOf(8) !== -1
                  : false
              }
              value={8}
            >
              新聞報導
            </option>
            <option
              selected={
                this.props.data.category_ids
                  ? this.props.data.category_ids.indexOf(9) !== -1
                  : false
              }
              value={9}
            >
              專題訪談
            </option>
            <option
              selected={
                this.props.data.category_ids
                  ? this.props.data.category_ids.indexOf(162) !== -1
                  : false
              }
              value={162}
            >
              影片廣告
            </option>
          </Input>
        </FormGroup>

        <FormGroup>
          <label className="form-control-label" htmlFor="example-date-input">
            發布日期
          </label>
          <Input
            id="example-date-input"
            type="date"
            value={this.formatTime(this.props.data.published_at)}
            onChange={(e) => this.props.onTextInputChange(e, "published_at")}
          />
        </FormGroup>
      </div>
    );
  }
}

export default ArticleForm;
